







































import DateFormat from '@/shared/utils/date-format';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class SelectSingleMonth extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  }) disabled!: boolean;

  @Prop({
    type: String,
    default: '',
  }) month!: string;

  @Prop({
    type: Boolean,
    default: false,
  }) readonly!: boolean;

  @Prop({
    type: String,
    default: '290',
  }) maxWidth!: string;

  @Prop({ default: () => ([]) }) rules!: Array<Function>;

  @Prop({
    type: Boolean,
    default: false,
  }) closePickerMenuOnSelect!: boolean;

  pickerMenu: boolean = false;

  get monthFormatted() {
    const month = DateFormat.localDateToLocal(this.month);
    return DateFormat.fullMonthAndYear(month);
  }

  change(value: string) {
    if (this.closePickerMenuOnSelect) {
      this.pickerMenu = false;
    }
    this.$emit('change', value);
  }
}
